import { ref, onMounted } from "vue";

const isDarkMode = ref(false);

export function useTheme() {
    const toggleTheme = () => {
        isDarkMode.value = !isDarkMode.value;
        // Save preference to localStorage
        localStorage.setItem("darkMode", isDarkMode.value.toString());
        // Update document class
        document.documentElement.classList.toggle("dark-mode", isDarkMode.value);
    };

    const initTheme = () => {
        // Check localStorage first, then system preference
        const savedTheme = localStorage.getItem("darkMode");
        if (savedTheme !== null) {
            isDarkMode.value = savedTheme === "true";
        } else {
            // Check system preference
            isDarkMode.value = window.matchMedia("(prefers-color-scheme: dark)").matches;
        }
        // Apply theme
        document.documentElement.classList.toggle("dark-mode", isDarkMode.value);

        // Listen for system theme changes
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
            // Only update if user hasn't set a manual preference
            if (localStorage.getItem("darkMode") === null) {
                isDarkMode.value = e.matches;
                document.documentElement.classList.toggle("dark-mode", isDarkMode.value);
            }
        });
    };

    onMounted(() => {
        initTheme();
    });

    return {
        isDarkMode,
        toggleTheme,
    };
}
